import { Link } from "react-router-dom";
import img1 from "../../assets/Images/Access Control/Role Management.png"
import img2 from "../../assets/Images/Access Control/User Management.png"
import DocNavigation from "../../components/DocNavigation";

export default function MultiUserAccessControl() {
  return (
    <section className="space-y-8">

      <section className="bg-white rounded-xl border border-slate-200 p-10">
        <h1 className="text-2xl font-bold text-slate-900 mb-4">
          Multi-user Access Control
        </h1>

        <p className="text-md text-slate-600 max-w-4xl">
          As banquet operations grow, multiple staff members interact with the
          system daily. EventFlow ensures data security and accountability
          through role-based access control.
        </p>

        <section className="border-l border-[#C9A24E] pl-4 mt-6">
          <h2 className="text-lg font-semibold mb-3">Overview</h2>
          <p className="text-slate-600 text-sm">
            EventFlow follows a structured role-based access control (RBAC)
            system, allowing administrators to define who can access what.
          </p>
        </section>
      </section>

      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-4">Why Access Control Is Critical</h3>
        <ul className="list-disc pl-5 text-slate-600 space-y-2">
          <li>Prevents unauthorized data access</li>
          <li>Reduces internal fraud risks</li>
          <li>Clearly defines staff responsibilities</li>
          <li>Protects financial and booking data</li>
        </ul>
      </section>

      <section className="p-4">
        <div>
          <h3 className="font-semibold mb-3">EventFlow Access Model</h3>
          <ul className="list-disc pl-5 text-slate-600 space-y-1">
            <li>Role-based permissions (Admin, Manager, Staff)</li>
            <li>Module-level access configuration</li>
            <li>Centralized user management</li>
            <li>Controlled create/edit/delete actions</li>
          </ul>
        </div>

        <div className="rounded-lg p-6 flex flex-col justify-center items-center gap-10">
          <img src={img1} alt="" className="shadow-lg" />
          <img src={img2} alt="" className="shadow-lg"/>
        </div>
      </section>

      <section className="bg-slate-100 rounded-xl p-8">
        <p className="text-slate-600 max-w-4xl">
          With multi-user access control, EventFlow ensures that every action is
          intentional, traceable, and aligned with staff responsibilities.
        </p>
      </section>
{/* 
      <section className="border-t pt-8 mt-12">
        <p className="text-slate-600">
          Next, learn about{" "}
          <Link to="/docs/records" className="font-medium text-[#C9A24E]">
            Organized Record Keeping
          </Link>.
        </p>
      </section> */}
  <DocNavigation
              previous={{
                title: "Real-time Financial Insights",
                link: "/docs/financial-insights"
              }}
              next={{
                title: "Organized Record Keeping",
                link: "/docs/records"
              }}
            />

    </section>
  );
}
